import './App.css';
import { ThemeNavBar } from '@evolution-james/evolution-theme-engine';
import { Link } from 'react-router-dom';

function App() {
  return (
    <>
      <ThemeNavBar
        title="Evolution Theme Engine"
        titleHref="/"
        links={[
          { label: 'Home', href: '/' },
          { label: 'About', href: '/about' },
          { label: 'Contact', href: '/contact' },
        ]}
        renderLink={(props) => (
          <Link to={props.href} className={props.className}>{props.children}</Link>
        )}
      />
      <div class="container">
        <h1>Evolution Theme Engine</h1>
        <div class="editor-subtitle">Developed by <a href="https://github.com/james-evolution" target="_blank" rel="noopener noreferrer">@james-evolution</a></div>
        <p>
          Welcome to the Evolution Theme Engine demo.
        </p>
        <p>
          If you use the ThemeNavBar component, it is recommended that you use it in conjunction with React Router.
          If you don't, then links are rendered as standard anchor tags, and the page will refresh on click.
        </p>
        <p>
          If you do use React Router, then links are rendered as Link components, and the page will not refresh on click, provided that you utilize the renderLink prop as outlined in the <a href="https://github.com/james-evolution/evolution-theme-engine#readme">documentation</a>. This demo uses React Router as described. If you wish, you can view the demo's source code <a href="https://github.com/james-evolution/evolution-theme-engine-demo">here</a>.
        </p>

      </div>
    </>
  );
}

export default App;
